import axios from 'axios';
import { get } from 'lodash-es';

export const getAllIntegrations = async () => {
  try {
    const response = await axios.get('/integrations/all');
    const result = get(response, 'data') ?? [];
    return result;
  } catch (error) {
    throw new Error(`Error getting all integrations : ${error?.message}`, { cause: error });
  }
};

export const getReturnRabbitKey = () => {
  return axios.get('returnrabbit');
};

export const createReturnRabbitKey = () => {
  return axios.post('returnrabbit');
};

export const getAllWebhooks = async () => {
  try {
    const response = await axios.get('/webhooks');
    const result = get(response, 'data') ?? [];
    return result;
  } catch (error) {
    throw new Error(`Error getting all webHooks: ${error?.message}`, { cause: error });
  }
};

export const addWebhook = async (data) => {
  try {
    const response = await axios.post('/webhooks', data);
    const result = get(response, 'data') ?? [];
    return result;
  } catch (error) {
    throw new Error(`Error adding a webHook: ${error?.message}`, { cause: error });
  }
};

export const editWebhook = async (data) => {
  try {
    const response = await axios.put('/webhooks', data);
    const result = get(response, 'data') ?? [];
    return result;
  } catch (error) {
    throw new Error(`Error editing a webHook: ${error?.message}`, { cause: error });
  }
};

export const deleteWebhook = async (webHookId) => {
  try {
    const response = await axios.delete(`/webhooks/${webHookId}`);
    const result = get(response, 'data') ?? [];
    return result;
  } catch (error) {
    throw new Error(`Error deleting a webhook : ${error?.message}`, { cause: error });
  }
};

export const getShipperHQConnections = () => {
  return axios.get('/shipperhqconnection');
};

export const createShipperHQConnection = (payload) => {
  return axios.post('/shipperhqconnection', payload);
};

export const updateShipperHQConnection = (payload) => {
  return axios.put('/shipperhqconnection', payload);
};

export const deleteShipperHQConnection = (storeGuid) => {
  return axios.delete(`/shipperhqconnection/${storeGuid}`);
};

export const getShipperHQConnectedStoreGuids = () => {
  return getShipperHQConnections()
    .then((res) => {
      if (res.data) {
        return res.data.map((config) => config.storeGuid);
      }
    })
    .catch((err) => {
      throw new Error(`Error getting ShipperHQ Connection: ${err}`, { cause: err });
    });
};

export const getGoogleConnections = () => {
  return axios.get('/google');
};

export const setGoogleConnections = async (payload) => {
  try {
    const response = await axios.post('/google', payload);
    const result = get(response, 'data') ?? [];
    return result;
  } catch (error) {
    throw new Error(`Error updating Google Stores : ${error?.message}`, { cause: error });
  }
};

export const getOauthIntegrations = (oauthIntegrationId) => {
  return axios.get(`/integrations/oauth?oauthIntegrationId=${oauthIntegrationId}`);
};

export const revokeOauthIntegration = (id) => {
  return axios.delete(`/integrations/oauth/revoke/${id}`);
};

export const getKlaviyoEventSubscriptions = async () => {
  try {
    const response = await axios.get('/klaviyo/event-subscription');
    return get(response, 'data');
  } catch (error) {
    throw new Error(`Error getting Klaviyo event subscriptions: ${error?.message}`, { cause: error });
  }
};

export const setKlaviyoEventSubscriptions = async (payload) => {
  try {
    const response = await axios.put('/klaviyo/event-subscription', payload);
    return get(response, 'data');
  } catch (error) {
    throw new Error(`Error saving Klaviyo event subscriptions: ${error?.message}`, { cause: error });
  }
};

export const createKlaviyoHistoricalExport = async (payload) => {
  try {
    const response = await axios.post('/klaviyo/historical-export', payload);
    return get(response, 'data');
  } catch (error) {
    throw new Error(`Error submitting Klaviyo historical export: ${error?.message}`, { cause: error });
  }
};

export const getKlaviyoHistoricalExports = async () => {
  try {
    const response = await axios.get('/klaviyo/historical-export');
    return get(response, 'data') ?? [];
  } catch (error) {
    throw new Error(`Error getting Klaviyo export history: ${error?.message}`, { cause: error });
  }
};

export const disconnectKlaviyo = async () => {
  try {
    const response = await axios.delete('/klaviyo/connection');
    return get(response, 'data');
  } catch (error) {
    throw new Error(`Error disconnecting from Klaviyo: ${error?.message}`, { cause: error });
  }
};

export const getKlaviyoOAuthConnectUrl = () => {
  // Deployed environments run on ship*.shipstation.com, but the legacy WebApi (DataDriven OAuth)
  // is served from ss*.shipstation.com. Rewrite accordingly. Non-ship hosts (local, previews)
  // are left unchanged by the replace — the backend must be reachable at the same hostname.
  const hostname = window.location.hostname.replace(/^ship/, 'ss');
  return `${window.location.protocol}//${hostname}/api/datadriven/oauth/connect/IntegratedApp/klaviyo?autoConnect=true`;
};
